import { Outlet, createFileRoute } from '@tanstack/react-router'

import { CompanyPage } from '@/app/manager/CompanyPage/CompanyPage'

export const Route = createFileRoute('/company/_management/events/add')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CompanyPage>
      <Outlet />
    </CompanyPage>
  )
}
